import { print } from 'services/printer.service';
import {
  confirmPrintShipment,
  getContent,
} from 'services/shipment-labels.service';
import { runSequentially } from 'modules/run-sequentially/run-sequentially';

export async function printLabelCollection(
  label_ids,
  reference,
  zebra,
  printBlankLabel = false,
) {
  const blankLabel = `^XA\\n^FX\\n^CFA,40\\n^A0N,50,40^FO50,100^FDETIQUETA SEPARADORA^FS\\n^A0N,50,40^FO50,300^FDREFERENCIA^FS\\n^A0N,40,40^FO50,380^FD${reference}^FS\\n^XZ`;
  try {
    await runSequentially(
      label_ids,
      async (label_id) => {
        try {
          const {
            data: { content },
          } = await getContent(label_id);
          await print(zebra, content);
        } catch (error) {
          throw error;
        }
      },
      {
        msBetweenEachRun: 2000,
      },
    );
    await confirmPrintShipment(reference);
  } catch (error) {
    throw error;
  }
  if (printBlankLabel) await print(zebra, blankLabel);
}

export async function printLabelCollectionWithBlankLabel(label_ids, zebra) {
  return printLabelCollection(label_ids, zebra, true);
}
